import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./Stackbar.css"; // Create a corresponding CSS file for styling
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Draggable from "react-draggable";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Paper, Button, Tooltip } from "@mui/material";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
const Stackbar = () => {
  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    maximumFractionDigits: 0,
  });
  const active_ = useSelector((state) => state.active);
  const exhausted_ = useSelector((state) => state.exhausted);
  const [active, setActiveData] = useState(
    Array.isArray(active_) ? active_ : []
  );
  const [exhausted, setExhaustedData] = useState(
    Array.isArray(exhausted_) ? exhausted_ : []
  );

  useEffect(() => {
    setActiveData(Array.isArray(active_) ? active_ : []);
    setExhaustedData(Array.isArray(exhausted_) ? exhausted_ : []);
  }, [active_, exhausted_]);

  const exhaustedTotal = exhausted.length;
  const activeAssetTotal = active.length;
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const [labelName, setLabelName] = React.useState("");
  const handleClose = () => {
    setOpen(false);
    setLabelName("");
  };
  const [dataShow, setData] = React.useState([]);
  React.useEffect(() => {
    if (labelName !== "") {
      handleModal();
    }
  }, [labelName]);
  // Example usage:
  function handleModal() {
    if (labelName === "active") {
      setData(active);
    }
    if (labelName === "exhausted") {
      setData(exhausted);
    }

    handleClickOpen();
  }
  const columns =
    dataShow.length > 0
      ? Object.keys(dataShow[0])
          .filter((key) => key !== "_id")
          .map((key) => ({
            field: key,
            headerName: key,
            minWidth: 170,
            align: "left",
          }))
      : [];
  return (
    <div className="stackbar-container">
      <Tooltip title="click to view data">
        <div
          onClick={() => setLabelName("active")}
          className="stackbar-segment"
          style={{
            width: `${activeAssetTotal}%`,
            backgroundColor: "#3D4F58",
            cursor: "pointer",
          }}
        >
          active assets: {currencyFormatter.format(activeAssetTotal)}
        </div>
      </Tooltip>
      <Tooltip title="click to view data">
        <div
          onClick={() => setLabelName("exhausted")}
          className="stackbar-segment"
          style={{
            width: `${exhaustedTotal}%`,
            backgroundColor: "rgba(255, 99, 132, 0.5)",
            color: "#000",
            cursor: "pointer",
          }}
        >
          exhausted assets: {currencyFormatter.format(exhaustedTotal)}
        </div>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {labelName} Assets
        </DialogTitle>
        <DialogContent>
          <Paper>
            <DataGrid
              columns={columns}
              getRowId={(row) => row._id}
              rows={dataShow}
              slots={{ toolbar: GridToolbar }}
              style={{ height: "50vh" }}
              disableRowSelectionOnClick
            />
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Stackbar;
